module.exports = __webpack_public_path__ + "static/media/header.f14bd9b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/giftcard/header.png
// module id = 1858
// module chunks = 6